// extracted by mini-css-extract-plugin
module.exports = {"head":"head___3t5sx","light":"light___1ISAH","main":"main___Oz6Ru","wide":"wide___2dSvU","left":"left___WkUJh","right":"right___34482","logo":"logo___2pKKe","menu":"menu___3Oqqv"};